/**
 * Type for dictionary objects
 */
export type Dictionary = Record<string | symbol, any>;

/**
 * Check if a value is a plain object (dictionary)
 */
export function isDictionary(value: unknown): value is Dictionary {
  return Object.prototype.toString.call(value) === "[object Object]";
}
